import Onboarding from "components/Onboarding"
import VueComponent from "../vue_component"

export default VueComponent(Onboarding)
